import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { TruncatedBox } from '@/components';
import { Link } from '@/containers';
import { Episode } from '@/types';

import { SpeakerBioModal } from '..';

export const Speakers = ({ episode }: { episode: Episode }) => {
  const [showSpeakerBio, setShowSpeakerBio] = useState(false);

  const { speakers, speakerBio } = episode;

  if (!speakers?.length) return null;

  const onSpeakerBioClick = () => setShowSpeakerBio(true);

  return (
    <>
      <TruncatedBox truncatedContentHeight={200}>
        <Typography variant="h3" sx={styles.title}>
          Speakers
        </Typography>
        <Box sx={styles.listContainer}>
          {speakers.map((speaker, index) => (
            <Box key={index} sx={styles.speakerContainer}>
              <Link to={speaker.companyUrl} target="_blank">
                <Box
                  component="img"
                  alt="company logo"
                  src={speaker.companyLogo}
                  sx={styles.companyLogo}
                />
              </Link>
              <Box sx={styles.speakerText}>
                <Link onClick={onSpeakerBioClick}>
                  <Typography sx={{ textAlign: 'left' }} variant="body3">
                    {speaker.name}
                  </Typography>
                </Link>
                <Typography variant="body3">{speaker.title}</Typography>
                <Link to={speaker.companyUrl} target="_blank">
                  <Typography variant="body3">{speaker.companyName}</Typography>
                </Link>
              </Box>
            </Box>
          ))}
        </Box>
      </TruncatedBox>
      <SpeakerBioModal
        isOpened={showSpeakerBio}
        setOpened={setShowSpeakerBio}
        speakerBio={speakerBio}
      />
    </>
  );
};

const styles = {
  title: {
    mb: 2,
  },
  listContainer: {
    display: 'grid',
    rowGap: 2,
    columnGap: 1.5,
    gridTemplateColumns: {
      xs: '1fr',
      lg: 'repeat(2, 1fr)',
    },
  },
  speakerContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 1.5,
  },
  speakerText: {
    display: 'flex',
    flexDirection: 'column',
    ml: 1,
  },
  companyLogo: {
    width: 48,
    height: 48,
    objectFit: 'cover',
    borderRadius: 2,
    borderColor: 'grey75',
    borderWidth: '1px',
    borderStyle: 'solid',
  },
};
